import { Box, Paper, Typography, useTheme } from "@mui/material";
import { FilePreview } from "components/Document/shared";
import { SubmissionDocument } from "./DocumentUploadSection";

interface DocumentPreviewSectionProps {
  selectedDocument?: SubmissionDocument | null;
  previewUrl?: string | null;
  fileExtension?: string;
}

export function DocumentPreviewSection({
  selectedDocument,
  previewUrl,
  fileExtension,
}: DocumentPreviewSectionProps) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        height: "calc(100vh - 230px)",
        maxHeight: "600px",
        paddingTop: theme.spacing(1),
      }}
    >
      {selectedDocument && previewUrl ? (
        <Box sx={{ height: "100%", position: "relative" }}>
          <FilePreview fileUrl={previewUrl} fileExtension={fileExtension} />
        </Box>
      ) : (
        <Paper
          variant="outlined"
          sx={{
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 0,
          }}
        >
          <Typography
            align="center"
            sx={{
              color: theme.palette.text.secondary,
              fontSize: "14px",
              lineHeight: 1.5,
            }}
          >
            Once a submission document has been
            <br />
            uploaded, it can be previewed here
          </Typography>
        </Paper>
      )}
    </Box>
  );
}
